import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPostAutoDebitAccountBody } from 'src/app/feature/BNPL/shared/models/automaticDebits.model';
import {
  IDebitAccounts,
  IDebitAccountsBody,
} from 'src/app/feature/BNPL/shared/models/debitAccounts.model';
import { BnplService } from 'src/app/feature/BNPL/shared/services/bnpl.service';
import { DebitAccountsService } from 'src/app/feature/BNPL/shared/services/debit-accounts.service';
import { maskText } from 'src/app/feature/BNPL/shared/utils/maskText';

@Component({
  selector: 'app-select-debit',
  templateUrl: './select-debit.component.html',
  styleUrls: ['./select-debit.component.css'],
})
export class SelectDebitComponent {
  @Output() changeStep = new EventEmitter<number>();
  @Output() sendEntitys = new EventEmitter<IDebitAccounts[] | null>();
  @Output() setAutoDebitAccount =
    new EventEmitter<IPostAutoDebitAccountBody | null>();
  @Output() setAutoDebitAccountImage = new EventEmitter<string>();
  @Output() changeAutomaticDebit = new EventEmitter<boolean>();
  @Input() visbleCancel: boolean = true;

  debits: IDebitAccounts[] | null = null;
  message: string | null = null;
  selectedDebit: IDebitAccounts | null = null;
  entitys: IDebitAccounts[] | null = null;
  maskText = maskText;

  constructor(
    private debitAccountsService: DebitAccountsService,
    private bnplService: BnplService
  ) {}

  ngOnInit() {
    this.handleAccounts();
  }

  handleAddCredit(step: number) {
    this.sendEntitys.emit(this.entitys);
    this.changeStep.emit(step);
  }

  handleAccounts() {
    const body: IDebitAccountsBody = {
      primerApellido:
        this.bnplService.stepsInformation.secondStep.primerApellido,
      tipoDocumento: '1',
      numeroDocumento:
        this.bnplService.stepsInformation.firstStep.numeroDocumento,
    };
    this.debitAccountsService.getDebitAccounts(body).subscribe({
      next: (response) => {
        this.debits = response.datos;
        this.message = response.mensaje;
        this.entitys = response.bancos;
      },
      error: (error) => {
        console.error('Error al obtener los debitos', error);
      },
    });
  }

  handleSelectedDebit() {
    if (this.selectedDebit) {
      const transformDebit: IPostAutoDebitAccountBody = {
        personId: this.bnplService.stepsInformation.firstStep.numeroDocumento,
        bankName: this.selectedDebit.Nombre,
        bankCode: this.selectedDebit.Codigo,
        accountType: this.selectedDebit.tipoCuenta,
        currency: 'PESOS',
        accountNumber: this.selectedDebit.numeroCuenta,
      };
      document.body.classList.remove('no-scroll');
      this.setAutoDebitAccount.emit(transformDebit);
      this.setAutoDebitAccountImage.emit(this.selectedDebit.url);
      this.changeAutomaticDebit.emit(false);
    } else {
      this.setAutoDebitAccount.emit(null);
      this.changeAutomaticDebit.emit(false);
    }
  }

  handleCancelBtn() {
    document.body.classList.remove('no-scroll');
    this.changeAutomaticDebit.emit(false);
  }
}
